import { useState } from 'react';
import Button from '../base/Button';
import Card from '../base/Card';

export default function QualificationForm() {
  const [formData, setFormData] = useState({
    nome: '',
    whatsapp: '',
    cidade: '',
    nascimento: '',
    situacao: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4d7l5m820p5j87gal30', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          whatsapp: '',
          cidade: '',
          nascimento: '',
          situacao: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section id="formulario" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
              Find out if you are entitled to the benefit
            </h2>
            <p className="text-xl text-gray-400">
              Fill out the form and our team will analyze your case for free
            </p>
          </div>

          <Card>
            <form onSubmit={handleSubmit} data-readdy-form id="qualification-form">
              <div className="space-y-6">
                <div>
                  <label htmlFor="nome" className="block text-white font-medium mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white text-sm focus:outline-none focus:border-amber-700"
                    placeholder="Enter your full name"
                  />
                </div>

                <div>
                  <label htmlFor="whatsapp" className="block text-white font-medium mb-2">
                    WhatsApp *
                  </label>
                  <input
                    type="tel"
                    id="whatsapp"
                    name="whatsapp"
                    value={formData.whatsapp}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white text-sm focus:outline-none focus:border-amber-700"
                    placeholder="(11) 99999-9999"
                  />
                </div>

                <div>
                  <label htmlFor="cidade" className="block text-white font-medium mb-2">
                    City/State *
                  </label>
                  <input
                    type="text"
                    id="cidade"
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white text-sm focus:outline-none focus:border-amber-700"
                    placeholder="São Paulo/SP"
                  />
                </div>

                <div>
                  <label htmlFor="nascimento" className="block text-white font-medium mb-2">
                    Date of Birth *
                  </label>
                  <input
                    type="date"
                    id="nascimento"
                    name="nascimento"
                    value={formData.nascimento}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white text-sm focus:outline-none focus:border-amber-700"
                  />
                </div>

                <div>
                  <label htmlFor="situacao" className="block text-white font-medium mb-2">
                    Briefly describe your situation *
                  </label>
                  <textarea
                    id="situacao"
                    name="situacao"
                    value={formData.situacao}
                    onChange={handleChange}
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white text-sm focus:outline-none focus:border-amber-700 resize-none"
                    placeholder="Describe your current situation and your questions..."
                  />
                  <div className="text-right text-gray-400 text-xs mt-1">
                    {formData.situacao.length}/500 characters
                  </div>
                </div>

                <Button
                  type="submit"
                  size="lg"
                  className="w-full"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin mr-2"></i>
                      Sending...
                    </>
                  ) : (
                    'Send my details'
                  )}
                </Button>

                {submitStatus === 'success' && (
                  <div className="text-green-400 text-center">
                    <i className="ri-check-line mr-2"></i>
                    Details sent successfully! Our team will contact you shortly.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="text-red-400 text-center">
                    <i className="ri-error-warning-line mr-2"></i>
                    Error sending. Try again or contact us via WhatsApp.
                  </div>
                )}

                <p className="text-gray-400 text-center text-sm">
                  After sending, our team analyzes your case and responds within 24 business hours.
                </p>
              </div>
            </form>
          </Card>
        </div>
      </div>
    </section>
  );
}
